// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"230":"ce377a66","3941":"7b8013a7","6937":"ce377a66","8665":"9c1b5a04"}[chunkId] + ".chunk.css";
};